import * as yup from 'yup';

export type CreateTagDto = {
  name: string;
};

export const createTagSchema: yup.SchemaOf<CreateTagDto> = yup.object({
  name: yup.string().required(),
});
